var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-list-skeleton" },
    _vm._l(4, function (i) {
      return _c("div", { key: i, staticClass: "skeleton-section pb-4" }, [
        _vm._m(0, true),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "skeleton-items pl-5 pt-2" },
          _vm._l(2, function (j) {
            return _c("div", { key: j, staticClass: "skeleton-item" }, [
              _c("div", { staticClass: "skeleton-bullet" }),
              _vm._v(" "),
              _c("div", { staticClass: "skeleton-text skeleton-text--label" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "skeleton-text skeleton-text--filename",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "skeleton-text skeleton-text--date" }),
            ])
          }),
          0
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-header" }, [
      _c("div", { staticClass: "skeleton-button" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-text skeleton-text--title" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }